/*
 * Copyright (c) Dito Technologies
 */

import {useCallback, useEffect, useState} from "react";
import {ACCESS_TOKEN_KEY} from "constants/keys";
import {AuthenticationContext} from "state/authentication";

export default function UseAuthentication(): AuthenticationContext {
    const [isAuthenticated, setIsAuthenticatedInternal] = useState<boolean | null>(null);
    const [initialLoadDone, setInitialLoadDone] = useState<boolean>(false);
    const [onAuthenticatedPath, setOnAuthenticatedPath] = useState<string | null>(null);

    useEffect(() => {
        const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
        if (accessToken) {
            setIsAuthenticatedInternal(true);
        } else {
            setIsAuthenticatedInternal(false);
        }
        setInitialLoadDone(true);
    }, []);

    const setAccessToken = useCallback(
        async (token: string | null) => {
            if (token) {
                localStorage.setItem(ACCESS_TOKEN_KEY, token);
                setIsAuthenticatedInternal(!!token);
                setInitialLoadDone(true);
            } else {
                localStorage.removeItem(ACCESS_TOKEN_KEY);
                setIsAuthenticatedInternal(!!token);
                setInitialLoadDone(true);
            }
        },
        [setIsAuthenticatedInternal, setInitialLoadDone]
    );

    return {
        initialLoadDone,
        setAccessToken,
        isAuthenticated: !!isAuthenticated,
        setOnAuthenticatedPath,
        onAuthenticatedPath,
    };
}